import debounce from '../util/debounce';
import * as scroll from '../util/body-scroll';
import { enableAfterFirstAnimation } from '../util/event-handlers';

/* Constants */
const CONTAINER = '.site-header-container';
const WRAPPER = '.header-wrapper';
const MENU = '.desktop-menu-wrapper';
const DROPDOWN = '.menu-products-dropdown';

const clearContainerClass = () => {
  // clear all other classes
  const scrolled = jQuery(CONTAINER).hasClass('scrolled');
  jQuery(CONTAINER)
    .removeClass()
    .addClass('site-header-container')
    .addClass(scrolled ? 'scrolled' : '');
};

/* Functions */
const showMenu = debounce(id => {
  clearContainerClass();
  jQuery(CONTAINER).addClass(`active-desktop ${id}`);
  scroll.lock();
}, 400);

const hideMenu = () => {
  showMenu.cancel();
  clearContainerClass();
  scroll.unlock();
};

const init = () => {
  enableAfterFirstAnimation(MENU);

  jQuery(DROPDOWN).on('mouseenter', function () {
    const id = jQuery(this).data('id');
    showMenu(id);
  });

  jQuery(CONTAINER).on('mouseleave', function () {
    hideMenu();
  });

  jQuery(`
  ${MENU} .backdrop, 
  ${WRAPPER} .menu-item:not(${DROPDOWN})
`).on('mouseenter', function () {
    hideMenu();
  });
};

export default init;
